module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "kp-logo",
    attrs: {
      "title": _vm.$t('general.labels.homepage')
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'index',
        params: {
          locale: _vm.i18n.locale
        }
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../../assets/hotmart-logo.svg"),
      "alt": _vm.$t('general.labels.hotmart_logo')
    }
  })])], 1)
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-f44b72e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/buttons/types/Logo.vue
 ** module id = 925
 ** module chunks = 1
 **/